"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/spin/style");
var _spin = _interopRequireDefault(require("antd/lib/spin"));
var _lodash = require("lodash");
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _api = require("./api");
var _utils = require("../../../utils");
var _components = require("../../../components");
var _SessionsManagement = _interopRequireDefault(require("./SessionsManagement"));
var _ = require("../..");
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var GroupSessions = function GroupSessions(_ref) {
  var group = _ref.group,
    upcomingSessions = _ref.upcomingSessions,
    rsvps = _ref.rsvps,
    onRefetchRsvps = _ref.onRefetchRsvps,
    action = _ref.action,
    _ref$onCloseSuccessMo = _ref.onCloseSuccessModal,
    onCloseSuccessModal = _ref$onCloseSuccessMo === void 0 ? _lodash.noop : _ref$onCloseSuccessMo,
    activeSession = _ref.activeSession,
    className = _ref.className,
    _ref$groupRegistratio = _ref.groupRegistrationModalVisible,
    groupRegistrationModalVisible = _ref$groupRegistratio === void 0 ? false : _ref$groupRegistratio,
    _ref$setGroupRegistra = _ref.setGroupRegistrationModalVisible,
    setGroupRegistrationModalVisible = _ref$setGroupRegistra === void 0 ? _lodash.noop : _ref$setGroupRegistra,
    _ref$onClickSignUp = _ref.onClickSignUp,
    onClickSignUp = _ref$onClickSignUp === void 0 ? _lodash.noop : _ref$onClickSignUp,
    forceMd = _ref.forceMd;
  var _useRsvpToSessions = (0, _api.useRsvpToSessions)(),
    rsvpProcessing = _useRsvpToSessions.processing;
  var _useCssMedia = (0, _utils.useCssMedia)(),
    isMdMediaQuery = _useCssMedia.md;
  var md = isMdMediaQuery || forceMd;
  var _useAuth = (0, _.useAuth)(),
    isAuthenticated = _useAuth.isAuthenticated;
  return (upcomingSessions || []).length > 0 && /*#__PURE__*/_react.default.createElement(_spin.default, {
    spinning: rsvpProcessing,
    wrapperClassName: "w-full md:w-auto"
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, md && /*#__PURE__*/_react.default.createElement("div", {
    className: "mt-[20px]"
  }, isAuthenticated && activeSession ? /*#__PURE__*/_react.default.createElement(_components.SecondaryButton, {
    size: "large",
    onClick: onClickSignUp,
    disabled: upcomingSessions.length === 0,
    className: (0, _classnames.default)('h-[46px] w-[320px]', className)
  }, "Register") : isAuthenticated && !activeSession ? /*#__PURE__*/_react.default.createElement(_components.PrimaryButton, {
    size: "large",
    onClick: onClickSignUp,
    disabled: upcomingSessions.length === 0,
    className: (0, _classnames.default)('h-[46px] w-[320px]', className)
  }, "Register") : /*#__PURE__*/_react.default.createElement(_components.PrimaryButton, {
    size: "large",
    onClick: onClickSignUp,
    className: (0, _classnames.default)('h-[46px] w-[320px]', className)
  }, "Sign Up To Register")), /*#__PURE__*/_react.default.createElement(_SessionsManagement.default, {
    isAuthenticated: isAuthenticated,
    upcomingSessions: upcomingSessions,
    group: group,
    rsvps: rsvps,
    onRefetchRsvps: onRefetchRsvps,
    sessionsModal: groupRegistrationModalVisible,
    setSessionsModal: setGroupRegistrationModalVisible,
    onClickSignUp: onClickSignUp,
    md: md
  })));
};
GroupSessions.propTypes = {
  group: _propTypes.default.object,
  upcomingSessions: _propTypes.default.array,
  rsvps: _propTypes.default.array,
  onRefetchRsvps: _propTypes.default.func,
  action: _propTypes.default.string,
  onCloseSuccessModal: _propTypes.default.func,
  activeSession: _propTypes.default.object,
  className: _propTypes.default.string,
  groupRegistrationModalVisible: _propTypes.default.bool,
  setGroupRegistrationModalVisible: _propTypes.default.func,
  onClickSignup: _propTypes.default.func
};
var _default = GroupSessions;
exports.default = _default;